/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function scan(params) {
    // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
    var formatOutput = function (ret) {
        var _a;
        // 统一成uni官方淘宝一致的API字段输出：https://uni-apis.alibaba-inc.com/doc/Device/scan
        // 菜鸟容器只返回result字符串，无其他属性
        var qrCode = (_a = ret === null || ret === void 0 ? void 0 : ret.data) === null || _a === void 0 ? void 0 : _a.result;
        return {
            code: qrCode,
            qrCode: qrCode,
            barCode: qrCode,
        };
    };
    WVCall('CNHybridGGScanner.jumpScannerPage', params, {
        formatOutput: formatOutput,
    });
}

export { scan as default };
